import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
import { CHECKOUT_URL, PRICE, TOTAL_VALUE } from '../data/product';
const included = ['6 volumes · 121 Fence Card Sessions', '60, 75 and 90-minute versions of every practice', '39 worksheets + 6 printable field cards', '5 bonuses, incl. the Fence Station Sign Kit', 'Level Dial for Youth, Middle School and High School', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-chalk-light text-ink" data-id="element-295" data-mp="25s7x1cec7431">
      <div className="mx-auto max-w-2xl px-5 py-16 sm:py-20" data-id="element-296" data-mp="20tegfb3r6wyn">
        <div className="text-center" data-id="element-297" data-mp="20rtn1ot6dk2d">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-clay" data-id="element-298" data-mp="3h74nmqq661ci">Complete megapack</p>
          <h2 id="pricing-heading" className="mt-3 font-display text-3xl text-ink sm:text-5xl" data-id="element-299" data-mp="3c8tdsfzvjqua">
            Your whole season, planned
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-chalk-dark bg-white shadow-soft" data-id="element-300" data-mp="3w1jk8em9364n">
          <div className="bg-navy px-5 py-5 text-center" data-id="element-301" data-mp="4uyvj1jo4aas">
            <h3 className="font-display text-xl font-bold uppercase tracking-wide text-chalk sm:text-2xl" data-id="element-302" data-mp="9tjvczv0cryp">
              Track Coach Ready: The Complete Practice Megapack
            </h3>
            <p className="mt-1 text-[13px] font-semibold uppercase tracking-widest text-hl" data-id="element-303" data-mp="3da0dpxt0p9xv">6 Volumes + 5 Bonuses</p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-304" data-mp="3i8bs8lu9c8mf">
            <div id="offer" className="scroll-mt-4 overflow-hidden rounded-2xl bg-navy px-2 pb-1 pt-4" data-id="element-305" data-mp="3n6lkooolkv4c">
              <ProductVisual seal={false} lazy data-id="element-306" data-mp="3rydfxcip7p0t" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-307" data-mp="3rzoij90eqqqc">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink" data-id="element-308" data-mp="2zhkjnmi3gm93">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-infield" data-id="element-309" data-mp="2zfg4u9inq2u1">
                    <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-310" data-mp="2mi1j9cr3tp9c" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-chalk-dark pt-6 text-center" data-id="element-311" data-mp="2w7l58ra45z8f">
              <p className="text-[13px] text-ink-soft" data-id="element-312" data-mp="2w9o480t8v2pa">
                Total value <span className="line-through" data-id="element-313" data-mp="28is7cp9xlhb6">${TOTAL_VALUE} USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-ink" data-id="element-314" data-mp="23jz1nj0vyulk">
                <span className="mt-2.5 font-display text-3xl font-bold" data-id="element-315" data-mp="2iggdscgwgd96">$</span>
                <span className="font-display text-[60px] font-bold leading-[0.9] sm:text-7xl" data-id="element-316" data-mp="2dhd7ypt3i305">{PRICE}</span>
                <span className="mt-3 text-[13px] font-semibold text-ink-muted" data-id="element-317" data-mp="3tutwz40pk4iv">USD</span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-318" data-mp="3ox1uxh6cn20y">
                <span className="rounded bg-hl px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-hl-ink" data-id="element-319" data-mp="adnax2mu5m6">
                  Save ${TOTAL_VALUE - PRICE}
                </span>
                <span className="rounded border border-chalk-dark px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-320" data-mp="3nf37kwrzm7y1">
                  One-time payment
                </span>
                <span className="rounded border border-chalk-dark px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-321" data-mp="j0vdatw2yn3u">
                  No app, no subscription
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-322" data-mp="a7i92vskfz2g">
                Get Track Coach Ready — only ${PRICE}
              </CtaButton>

              <p className="mt-3 text-xs text-ink-soft" data-id="element-323" data-mp="e823hrlr8okw">Backed by the 7-day money-back guarantee</p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-324" data-mp="11xmqqmoxy7zz">
                <li className="flex items-center gap-1.5" data-id="element-325" data-mp="3f7ilqb55k2pm">
                  <LockIcon className="h-4 w-4 text-infield" aria-hidden="true" data-id="element-326" data-mp="3f93epwbtjdld" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-327" data-mp="359ck7un9cyla">
                  <ZapIcon className="h-4 w-4 text-infield" aria-hidden="true" data-id="element-328" data-mp="359unhb8c8d2p" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-329" data-mp="1sm7yy131pb5">
                  <ShieldCheckIcon className="h-4 w-4 text-infield" aria-hidden="true" data-id="element-330" data-mp="1s45hjntueus" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-soft" data-id="element-331" data-mp="3o6drxn875csx">
          Price in USD. You&apos;ll be charged the equivalent in your local currency, whatever it is.
        </p>
      </div>
    </section>;
}